import { UserStateContextType } from 'components/constants/Constants';
import { useUserState } from 'context/User';
import { isBuyer, isSupplier, isSupport } from 'helpers/Roles';

export enum RequestsPageVariant {
  BUYER = 'BUYER',
  SUPPLIER = 'SUPPLIER',
  SUPPORT = 'SUPPORT'
}

export const useRequestsPageVariant = () => {
  const userState = useUserState();
  if (userState.type !== UserStateContextType.AUTHENTICATED) return null;
  if (isSupport(userState.user)) {
    return RequestsPageVariant.SUPPORT;
  } else if (isSupplier(userState.user)) {
    return RequestsPageVariant.SUPPLIER;
  } else if (isBuyer(userState.user)) {
    return RequestsPageVariant.BUYER;
  }
  return null;
};
